import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Globals } from 'src/app/globals';
import { TranslateService } from '@ngx-translate/core';
import { AcademicsService } from 'src/app/service/academics.service';
import { forkJoin } from 'rxjs';
@Component({
  selector: 'app-teacher-course-update',
  templateUrl: './teacher-course-update.component.html',
  styleUrls: ['./teacher-course-update.component.scss']
})
export class TeacherCourseUpdateComponent implements OnInit {

showLoader: boolean = false;
  updating: boolean = false;
  teacherCourseId: any;
  teachers: any;
  courses: any;
  orgId: any;
  username: any;

  updateTeacherCourse = new FormGroup({
    teacher: new FormControl('', [
      Validators.required,
    ]),
    // teacherType: new FormControl('', [
    //   Validators.required,
    // ]),
    course: new FormControl('', [
      Validators.required, 
    ]),
    courseType: new FormControl('', [
      Validators.required,
    ]),
    remarks: new FormControl('', [
      // Validators.required,
    ]),
    active: new FormControl('', [
      Validators.required,
    ]),
  });


  constructor(
    private toastrService: ToastrService
    , public globals: Globals, private toastr: ToastrService, private activatedRoute: ActivatedRoute, private router: Router
    , public translate: TranslateService, public academicsService: AcademicsService
  ) {

  }

  ngOnInit(): void {
    this.showLoader = true;
    this.activatedRoute
      .queryParams
      .subscribe(params => {
        this.teacherCourseId = params['teacherCourseId'] || "";

        if (this.teacherCourseId != "") {
          this.orgId = this.globals.currentUserInfo.orgid;
          this.username = this.globals.currentUserInfo.username;
          this.showLoader = true;
          this.getAciveTeachersAndCourses();
          // this.teachers = [
          //   {
          //     id: 1,
          //     teacherNameAr: "علي",
          //     teacherNameEn: "Ali"
          //   }
          // ]

          
        } else {
          this.toastrService.warning(this.translate.instant('CAN_NOT_GET_CALENDAR'));
          this.router.navigate(['/academics/teacher-courses']);
        }
      });


  }
  getTeacherCourseById() {
    this.academicsService.getTeacherCourse(this.teacherCourseId).subscribe(
      data => {
        // console.log(data);
        this.updateTeacherCourse.controls.teacher.setValue(data.teacherid);
        this.updateTeacherCourse.controls.course.setValue(data.subjectid);
        this.updateTeacherCourse.controls.courseType.setValue(data.primarySecondary);
        // this.updateTeacherCourse.controls.teacherType.setValue(data.teacherType);
        this.updateTeacherCourse.controls.remarks.setValue(data.remarks);
        this.updateTeacherCourse.controls.active.setValue(data.active);
        this.showLoader = false;
      },
      error => {
        this.showLoader = false;
        this.toastrService.error(this.translate.instant('FAIL_TO_CREATE'));
      }
    );

  }

  updateTeacherCourseChange() {
    // let classHours = this.updateTeacherCourse.controls.classHours.value;
    // let clinicalHours = this.updateTeacherCourse.controls.clinicalHours.value;
    // this.updateTeacherCourse.controls.totalHours.setValue(Number(classHours) + Number(clinicalHours));
  }

  updateTeacherCourseSubmit() {
    if (this.updateTeacherCourse.valid) {
      // console.log("updateing teacher course");
      // console.log(this.updateTeacherCourse.value);
      this.updateTeacherCourseData(
        this.updateTeacherCourse.controls.course.value,
        this.updateTeacherCourse.controls.teacher.value,
        this.updateTeacherCourse.controls.courseType.value,
        this.updateTeacherCourse.controls.remarks.value,
        this.updateTeacherCourse.controls.active.value
      );
    }else {
      this.updateTeacherCourse.markAllAsTouched();
      this.updateTeacherCourse.markAsDirty();
    }
  }

  updateTeacherCourseData(subjectid: number, teacherid: number, primarySecondary: string, remarks: string, active: string) {
    this.updating = true;

    this.academicsService.updateTeacherCourse(this.username, this.teacherCourseId, this.orgId, subjectid, teacherid, primarySecondary, remarks, active)
      .subscribe(
        data => {
          if (data.sts == "SUCCESS") {
            this.toastrService.success(this.translate.instant('UPDATED_SUCCESSFULLY'));
            this.router.navigate(['/academics/teacher-courses']);
          } else {
            this.updating = false;
            this.toastrService.error(this.translate.instant('FAIL_TO_UPDATE'));
          }
        },
        error => {
          this.updating = false;
          this.toastrService.error(this.translate.instant('FAIL_TO_UPDATE'));
        }
      );
  }

  // modifyDayType(subjectCode: string, subjectNameAr: string, subjectNameEn: string, classHours: number, practicalHours: number, creditHours: number, passDegree: number, minClassHours: number, minPracticalHours: number, fullDegree: number, active: string) {
  //   this.updating = true;
  //   let username = this.globals.currentUserInfo.username;
  //   let totalHours = Number(classHours) + Number(practicalHours);

  //   this.coursesService.updateTeacherCourse(username, this.courseId, 10, 30, subjectCode, subjectNameAr, subjectNameEn, classHours, practicalHours, totalHours, creditHours, passDegree, minClassHours, minPracticalHours, fullDegree, active)
  //     .subscribe(
  //       data => {
  //         console.log(data);
  //         if (data.sts == "SUCCESS") {
  //           // this.addPreCourses(data.id);
  //           this.deletePreCourses(this.courseId);
  //         } else {
  //           this.updating = false;
  //           this.toastrService.error(this.translate.instant('FAIL_TO_CREATE'));
  //         }
  //         this.updating = false;
  //       },
  //       error => {
  //         this.updating = false;
  //         this.toastrService.error(this.translate.instant('FAIL_TO_CREATE'));
  //       }
  //     );
  // }




  onItemSelect(item: any) {
    // console.log('onItemSelect', item);
  }

  changeactive() {

  }

  getAciveTeachersAndCourses(){
    let bulkApis = [
      this.academicsService.getActiveSubjectList(this.orgId),
      this.academicsService.getActiveTeacherList(this.orgId)
    ];

    forkJoin(bulkApis).subscribe(
      data => {
        // console.log(data);
        if(typeof data[0] != undefined)
          this.courses = data[0];

        if(typeof data[1] != undefined)
          this.teachers = data[1];
          this.getTeacherCourseById();
          // this.showLoader = false;
      },
      error => {
        this.toastrService.error(this.translate.instant("CAN_NOT_GET_DATA_BE"));
        this.showLoader = false;
      }
    );
  }
}


